import React, { useEffect } from 'react'
import Head from 'next/head'

import Header from 'app/Homepage/components/Header'
import InspirationRevampApp from 'app/InspirationPage/pages/InspirationRevamp'
import { useSETrackEvent } from 'app/InspirationPage/hooks/useSETrackEvent'

export const InspirationPage = () => {
  const { SETrackExploreOpenIdePraktik } = useSETrackEvent()

  useEffect(() => {
    SETrackExploreOpenIdePraktik()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Head>
        <title>Ide Praktik - Ruang GTK</title>
        <meta name="description" content="Jelajahi konten praktik terbaik" />
      </Head>

      <InspirationRevampApp />
    </>
  )
}

const PageHeader = () => <Header title="Ide Praktik" />

InspirationPage.layoutOpts = {
  hasHeader: false,
  header: PageHeader,
}

export default InspirationPage
